module.exports = __webpack_public_path__ + "img/ctrl-circuit-stub-+i.99ac5a37.svg";